export default __webpack_public_path__ + "static/media/longchamp18.4ecc3805.jpg";